import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';

interface Props {
  errorMessage: string;
}

export default function PaymentFormErrorMessage({ errorMessage }: Props) {
  if (!errorMessage) {
    return (
      <div style={{ display: 'none' }}>
        <p></p>
      </div>
    );
  }

  return (
    <ErrorContainer id="payment-form-error-message">
      <p>{errorMessage}</p>
    </ErrorContainer>
  );
}

const ErrorContainer = styled.div`
  padding: 20px 30px;
  margin: 0 auto 20px auto;
  background-color: ${Colors.ecru50};
  border: 1px solid ${Colors.red};
  border-radius: 2px;
  display: flex;
  align-content: center;

  p {
    font-family: 'BrownStd';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    color: ${Colors.red};
  }
`;
